import { render, staticRenderFns } from "./AddEditEligibilityModal.vue?vue&type=template&id=4dada6fe&scoped=true&"
import script from "./AddEditEligibilityModal.vue?vue&type=script&lang=js&"
export * from "./AddEditEligibilityModal.vue?vue&type=script&lang=js&"
import style0 from "./AddEditEligibilityModal.vue?vue&type=style&index=0&id=4dada6fe&prod&scoped=true&lang=scss&"
import style1 from "./AddEditEligibilityModal.vue?vue&type=style&index=1&id=4dada6fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dada6fe",
  null
  
)

export default component.exports